
import { useNavigate, useLocation } from 'react-router-dom';
import './PaymentPageComponent.css';

const PaymentPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  // Get the attendee details from the navigation state
  const { name, email, phone } = location.state || {};
  
  const handlePayment = () => {
    // Handle payment logic here
    alert('Payment of 1200 processed successfully!');
    // Navigate to success page or wherever needed
    navigate('/success');
  };
  
  const handleGoBack = () => {
    navigate('/register-now');
  };
  
  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission logic here
    console.log({ name, email, phone });
    alert('Registration submitted successfully!');
    // Navigate to success page or wherever needed
    navigate('/success');
  };

  return (
    <div className="payment-page">
      <div className="payment-container">
        <div className="header-section">
          <button className="go-back-btn" onClick={handleGoBack}>
            Go Back
          </button>
          <h1 className="register-title">Register Now</h1>
        </div>
        
        <form className="payment-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <input
              type="text"
              name="name"
              placeholder="Name"
              className="form-input"
              value={name || ''}
              readOnly
            />
          </div>
          
          <div className="form-group">
            <input
              type="email"
              name="email"
              placeholder="Email"
              className="form-input"
              value={email || ''}
              readOnly
            />
          </div>
          
          <div className="form-group">
            <input
              type="tel"
              name="phone"
              placeholder="Phone Number"
              className="form-input"
              value={phone || ''}
              readOnly
            />
          </div>
          
          <div className="payment-message">
            <p>You are not on the invitee list. Don't want to miss the chance of attending the event. Pay the money to reserve your seat</p>
          </div>
          
          <button type="button" className="payment-btn" onClick={handlePayment}>
            Pay 1200
          </button>
          
          <button type="submit" className="form-submit">Submit</button>
        </form>
      </div>
    </div>
  );
};

export default PaymentPage;